import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=c0e8eb9c&scoped=true&"
import script from "./PromoBanner.vue?vue&type=script&lang=js&"
export * from "./PromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromoBanner.vue?vue&type=style&index=0&id=c0e8eb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e8eb9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
